import React from 'react';
import PageTitle from '../headers/PageTitle';
import UploadFilesButton from '../FileManagement/UploadFilesButton';
import AddFolderButton from '../FileManagement/AddFolderButton';
import FilesTreeView from '../FileManagement/FilesTreeView';
import { useActualIncidentId } from './hooks/commonHooks';

const FilesPage: React.FC = () => {
  const incidentId = useActualIncidentId();

  // No onFilesUploaded handler needed: useUploadFiles already invalidates the
  // ['filesOrFolders', workspaceId] query key on success.
  return (
    <div className="files-page maincontent">
      <PageTitle title="File Management" parents={['Incident Management']}>
        <div className="d-flex align-items-center flex-column flex-md-row mb-3 mb-lg-0">
          <UploadFilesButton
            ownerId={incidentId}
            showNotificationText={false}
            showTooltip={false}
          />
          <AddFolderButton
            ownerId={incidentId}
            className="button--primary mt-2 mt-md-0 ms-md-2"
          />
        </div>
      </PageTitle>
      <div className="tab-wrapper content-gap-none">
        <FilesTreeView ownerId={incidentId} />
      </div>
    </div>
  );
};

export default FilesPage;
